import React, { PropsWithChildren } from 'react'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { Dropzone } from 'view/shared/upload'
import { createStructuredSelector } from 'reselect'
import { canManageAxeSelector } from 'selectors/permissionSelectors'
import { connect } from 'react-redux'
import { isNotEmpty, isNotNil } from 'utils/predicate'
import { AxeUploadDialog } from './AxeUploadDialog'

interface AxeDropzoneProviderProps extends ModalConsumerProps {
  canUploadAxe: boolean
}

const mapStateToProps = createStructuredSelector({
  canUploadAxe: canManageAxeSelector
})

class AxeDropzoneProviderComponent extends React.Component<PropsWithChildren<AxeDropzoneProviderProps>> {
  render() {
    const { children, canUploadAxe } = this.props
    if (!canUploadAxe) {
      return children
    }

    return <Dropzone render={() => <>{children}</>} onDropFiles={this.handleDropFiles} onPaste={this.handlePaste} />
  }

  handleDropFiles = (files: File[]) => {
    if (isNotNil(files[0])) {
      this.props.showModal(<AxeUploadDialog initialFile={files[0]} />)
    }
  }

  handlePaste = (clipboard: string) => {
    if (isNotEmpty(clipboard)) {
      this.props.showModal(<AxeUploadDialog initialClipboard={clipboard} />)
    }
  }
}

export const AxeDropzoneProvider = withModal(connect(mapStateToProps, {})(AxeDropzoneProviderComponent))
